import {IconButton, Stack, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Call02Icon, Clock01Icon, Delete02Icon} from "@hugeicons/core-free-icons";
import {CallStatusChipNew} from "../CampaignStatusChipsNew";
import {ConversationLink} from "../../../../project/campaigns/components/campaign-details/ConversationLink";
import {canCallNumber, formatDateTime} from "../../../../project/campaigns/utils";

const cellSx = {fontSize: 13, color: "#23264D", whiteSpace: "nowrap", borderBottom: "1px solid #F2F2F7"};
const iconButtonSx = {borderRadius: "50% !important", color: "#8A8AA0", "&:hover": {bgcolor: "#F4F4FA", color: "#4A4A63"}};

const callDisabledReason = (row, maxAttempts) => {
  if (row.status === "ACTIVE") return "A call is in progress";
  if (row.status === "ANSWERED") return "Already answered";
  if ((row.attempts ?? 0) >= maxAttempts) return "Max attempts reached";
  return null;
};

export const CampaignPhoneNumberRowNew = ({row, maxAttempts, projectId, calling, onCall, onShowAttempts, onDelete}) => {
  const canCall = canCallNumber(row, maxAttempts) && !calling;
  const attemptsDone = (row.attempts ?? 0) >= maxAttempts;

  return (
    <TableRow hover sx={{"&:hover": {bgcolor: "#FAFAFD"}}}>
      <TableCell sx={cellSx}>{row.phoneNumber}</TableCell>
      <TableCell sx={{borderBottom: "1px solid #F2F2F7"}}><CallStatusChipNew status={row.status}/></TableCell>
      <TableCell sx={cellSx}>
        <Typography component="span" sx={{fontSize: 13, fontWeight: attemptsDone ? 700 : 500, color: "#23264D"}}>
          {row.attempts ?? 0}
        </Typography>
        {` / ${maxAttempts}`}
      </TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{formatDateTime(row.lastQueuedAt)}</TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{row.lastCalledAt ? formatDateTime(row.lastCalledAt) : "Never"}</TableCell>
      <TableCell sx={cellSx}>
        <ConversationLink projectId={projectId} conversationId={row.lastConversationId}/>
      </TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{formatDateTime(row.dateUpdated)}</TableCell>
      <TableCell padding="checkbox" sx={{borderBottom: "1px solid #F2F2F7"}}>
        <Stack direction="row">
          <Tooltip title={callDisabledReason(row, maxAttempts) || "Call now"}>
            <span>
              <IconButton size="small" disabled={!canCall} onClick={() => onCall(row)} sx={{...iconButtonSx, "&:hover": {bgcolor: "rgba(47, 154, 106, 0.1)", color: "#2F9A6A"}}}>
                <HugeiconsIcon icon={Call02Icon} size={17}/>
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Call attempts">
            <IconButton size="small" onClick={() => onShowAttempts(row)} sx={iconButtonSx}>
              <HugeiconsIcon icon={Clock01Icon} size={17}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Remove from campaign">
            <IconButton size="small" onClick={() => onDelete(row)} sx={{...iconButtonSx, "&:hover": {bgcolor: "rgba(220, 38, 38, 0.08)", color: "#DC2626"}}}>
              <HugeiconsIcon icon={Delete02Icon} size={17}/>
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  )
}
